

import { municipalityOptions } from '@/config'
import { getMunicipalityNameByCode } from '@/services/municipalities'

/**
 * Realisation
 */
let Realisation = function ({
  cbapi, ref, data,
}) {

  if (cbapi) {
    data = this.commonCBAPIStructure({ data })
  } else {
    data = this.commonStructure({ ref, data })
  }

  data.tenant = 'go-ral'

  //
  Object.keys(data).forEach(key => {
    this[key] = data[key]
  })
}

Realisation.prototype.generateAddressData = function({ model }) {
  if (! model.CurrentLocation) {
    return 'Geen locatie gekozen'
  }
  
  const CurrentLocation = model.CurrentLocation
  const municipality = getMunicipalityNameByCode({ code: CurrentLocation.Municipality })
  const municipalityName = municipality && `(${municipality})`

  // CBAPI style
  if (model.cbapi && model.connectedLocations?.selected) {
    let location = this.$store.getters['chargingpoints/getChargingPointByUUID']({
      uuid: model.connectedLocations.selected?.locationUuid,
    })
    if (! location) return 'Geen locatie gekozen'

    if (location.isCBAPI()) {
      return location.getShortAddress()
    }

    location = location.data.address
    let number = (`${location.number || ''} ${location.suffix || ''}`).trim()
    return (`${location.street || ''} ${number}, ${location.city || ''} ${municipalityName}`).trim().trim(',')

    // Old style
  } else if (CurrentLocation.Location && CurrentLocation.Location.chargingpointUuid) {
    let location = this.$store.getters['chargingpoints/getChargingPointByUUID']({
      uuid: CurrentLocation.Location.chargingpointUuid,
    })
    if (! location) return 'Geen locatie gekozen'

    if (location.isCBAPI()) {
      return location.getShortAddress()
    }
    
    location = location.data.address
    let number = (`${location.number || ''} ${location.suffix || ''}`).trim()
    return (`${location.street || ''} ${number}, ${location.city || ''} ${municipalityName}`).trim().trim(',')
  }

  return 'Geen locatie gekozen'
}

Realisation.prototype.generateSearchData = ({ model, data }) => {

  let municipalityName = ''
  if (data.Municipality) {
    let municipalityOption = municipalityOptions.find(option => option.value === data.Municipality)
    if (municipalityOption) {
      municipalityName = municipalityOption.text
    }
  }

  return {
    City: model.CurrentLocation ? model.CurrentLocation.Location.CityName: '',
    Municipality: municipalityName,
  }
}


export default Realisation
